import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo, {"duration":200,"offset":-56,"easing":"ease-in-out"})

export default function (ctx, inject) {
    inject('scrollTo', VueScrollTo.scrollTo)
}
